import { v4 as uuidv4 } from 'uuid';

export const isUuid = (str) => {
  return str.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
};

export const getUuidV4 = () => {
  return uuidv4();
};

export const getUuidFromIri = (iri) => {
  if (typeof iri !== 'string') {
    return null;
  }

  return iri.split('/').pop();
};

export const getIdFromItem = (item, identifier = 'uuid') => {
  if (item === null) {
    return null;
  }

  if (Object.hasOwnProperty.call(item || {}, identifier)) {
    return item[identifier];
  }

  if (Object.hasOwnProperty.call(item || {}, '@id')) {
    return getUuidFromIri(item['@id']);
  }

  return getUuidFromIri(item);
};
